//引入axios
import axios from "axios";
import store from "../store";
import router from "../router";
import Qs from "qs";
import { Message } from "element-ui";
import { getToken, getName, setToken, removeToken } from "@/utils/auth";

let cancel,
  promiseArr = {};
const CancelToken = axios.CancelToken;
//异步请求前在header里加入token
axios.interceptors.request.use(
  config => {
    if (config.url === "/api/UserInfo/GenerateAccessToken") {
      //如果是登录和注册操作，则不需要携带header里面的token
    } else {
      if (getToken()) {
        config.headers.Authorization = "Bearer " + getToken();
        // config.headers.Authorization = getToken();
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
//请求拦截器
axios.interceptors.request.use(
  config => {
    //发起请求时，取消掉当前正在进行的相同请求
    // if (promiseArr[config.url]) {
    //   // promiseArr[config.url]("操作取消");
    //   promiseArr[config.url] = cancel;
    // } else {
    // }
    promiseArr[config.url] = cancel;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//响应拦截器即异常处理
axios.interceptors.response.use(
  response => {
    return response;
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '错误请求'
          break;
        case 401:
          err.message = '未授权，请重新登录'
          removeToken();
          router.push('/login');
          break;
        case 403:
          err.message = '拒绝访问'
          break;
        case 404:
          err.message = '请求错误,未找到该资源'
          break;
        case 405:
          err.message = '请求方法未允许'
          break;
        case 408:
          err.message = '请求超时'
          break;
        case 500:
          err.message = '服务器端出错'
          break;
        case 501:
          err.message = '网络未实现'
          break;
        case 502:
          err.message = '网络错误'
          break;
        case 503:
          err.message = '服务不可用'
          break;
        case 504:
          err.message = '网络超时'
          break;
        case 505:
          err.message = 'http版本不支持该请求'
          break;
        default:
          err.message = `连接错误${err.response.status}`
      }
    } else {
      // err.message = "连接到服务器失败"
    }
    if (err.message !== "错误请求") {
      Message.error(err.message);
    }
    return Promise.resolve(err.response);
  }
);

// 蚂蚁电竞测式环境
// axios.defaults.baseURL = 'http://tb.api.mayidianjing.com/'
// axios.defaults.baseURL =  'https://bapi.mayidianjing.com/'
axios.defaults.baseURL =
  window.location.host === "b.mayidianjing.com"
    ? window.location.protocol.indexOf("https") > -1
      ? "https://bapi.mayidianjing.com/"
      : "http://b.api.mayidianjing.com/"
    : "http://tb.api.mayidianjing.com/";

// 蚂蚁电竞正式环境
// axios.defaults.baseURL = 'http://b.api.mayidianjing.com/'

// 大象特权测式环境
// axios.defaults.baseURL = 'http://tb.api.haoyouzhushou.com/'
// 大象特权正式环境
// axios.defaults.baseURL = 'http://b.api.maihaoquan.com/'

// 即玩特权正式环境
// axios.defaults.baseURL = 'http://bq.api.maihaoquan.com/'

// 好玩特权正式环境
// axios.defaults.baseURL = 'http://bh.api.maihaoquan.com/'

// axios.defaults.tequan580 = 'http://localhost:8061'
// axios.defaults.mayidianjing = 'http://localhost:8061'

//设置默认请求头
axios.defaults.headers = {
  // Access-Control-Allow-Credentials:true,
  "Content-Type": "application/x-www-form-urlencoded"
  // 'Content-Type': 'application/json'
};
axios.defaults.timeout = 20000;

export default {
  //get请求
  get(url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url,
        params: param,
        cancelToken: new CancelToken(c => {
          cancel = c;
        })
      }).then(res => {
        resolve(res);
      });
    });
  },
  //post请求
  post(url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url,
        data: Qs.stringify(param),
        cancelToken: new CancelToken(c => {
          cancel = c;
        })
      }).then(res => {
        resolve(res);
      });
    });
  },
  defaults: axios.defaults
};



// WEBPACK FOOTER //
// ./src/utils/request.js